'use client';

import { createContext, useContext } from 'react';

interface ProvidedHeaders {
    Referer?: string;
}
const HeaderContext = createContext<ProvidedHeaders>({});
export const HeaderProvider= ({ headers, children }: {
    headers: ProvidedHeaders,
    children: React.ReactNode
}) => {
	return (
		<HeaderContext.Provider value={headers}>
			{children}
		</HeaderContext.Provider>
	);
}
export const useHeaders = () => {
	const context = useContext(HeaderContext);
	return context;
};
